import * as React from "react";
import { SVGProps } from "react";

const TrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12.696 4.088-.945 8.979a1.043 1.043 0 0 1-1.038.934H5.287a1.044 1.044 0 0 1-1.037-.934l-.945-8.98M2 4.088h12M5.652 4.087V2.522A.522.522 0 0 1 6.174 2h3.652a.522.522 0 0 1 .522.522v1.565M8 6.436v5.478M10.348 6.436l-.26 5.478M5.652 6.436l.261 5.478"
    />
  </svg>
);
export default TrashIcon;
